export default function isSessionExpired(timestamp, validity, validityUnit) {
  const currentTimestamp = new Date().getTime();
  const toMinute = validityUnit === 'HOURS' ? validity * 60 : validity;
  return (currentTimestamp - timestamp) / (60 * 1000) > toMinute;
}
